import { styled, keyframes } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const fromPositionX = -150;
const toPositionX = 600;

const shimmer = keyframes({
	'0%': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		backgroundPosition: `${fromPositionX}px 0`,
	},
	'100%': {
		backgroundPosition: `${toPositionX}px 0`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard
export const SkeletonBackground = styled.div({
	animationDuration: '1s',
	animationFillMode: 'forwards',
	animationIterationCount: 'infinite',
	animationName: shimmer,
	animationTimingFunction: 'linear',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.skeleton', colors.N30),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundImage: `linear-gradient( to right, ${token('color.skeleton', colors.N30)} 10%, ${token('color.skeleton.subtle', colors.N20)} 30%, ${token('color.skeleton', colors.N30)} 50% )`,
	backgroundRepeat: 'no-repeat',
	overflow: 'hidden',
	borderRadius: token('border.radius', '3px'),
});

// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FlexContainer = styled.div<{ marginBottom?: number }>(({ marginBottom = 0 }) => ({
	display: 'flex',
	alignItems: 'center',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginBottom: `${marginBottom}px`,
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Avatar = styled(SkeletonBackground)({
	width: token('space.300', '24px'),
	height: token('space.300', '24px'),
	borderRadius: '50%',
	flexShrink: 0,
	marginRight: token('space.150', '12px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled(SkeletonBackground)({
	width: '152px',
	height: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AttributeName = styled(SkeletonBackground)({
	margin: `${token('space.050', '4px')} ${token('space.100', '8px')} ${token('space.050', '4px')} 0`,
	height: token('space.200', '16px'),
	width: '168px',
	flex: '0 0 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AttributeValue = styled(SkeletonBackground)({
	margin: `${token('space.050', '4px')} 0`,
	height: token('space.200', '16px'),
	flex: '1 1 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LinkedIssueCard = styled(SkeletonBackground)({
	margin: `${token('space.050', '4px')} ${token('space.100', '8px')} ${token('space.050', '4px')} 0`,
	height: token('space.400', '32px'),
});
